export default __webpack_public_path__ + "static/media/i173jp.9f0adfa7.webp";